function describe(value: unknown): string {
  if (value === null) return "null";
  if (value === undefined) return "undefined";
  if (Array.isArray(value)) return `array com ${value.length} item(ns)`;
  if (typeof value === "object") return "object";
  if (typeof value === "string") return `"${value}"`;
  return String(value);
}

export function ensureObject(value: unknown, path: string): Record<string, unknown> {
  if (value === null || typeof value !== "object" || Array.isArray(value)) {
    throw new TypeError(
      `${path} deve ser um objeto (recebeu: ${describe(value)})`,
    );
  }
  return value as Record<string, unknown>;
}

export function ensureString(value: unknown, path: string): string {
  if (typeof value !== "string" || value.length === 0) {
    throw new TypeError(
      `${path} deve ser uma string não vazia (recebeu: ${describe(value)})`,
    );
  }
  return value;
}

export function ensureNumber(value: unknown, path: string): number {
  if (typeof value !== "number" || !Number.isFinite(value)) {
    throw new TypeError(
      `${path} deve ser um número finito (recebeu: ${describe(value)})`,
    );
  }
  return value;
}

export function ensureBoolean(value: unknown, path: string): boolean {
  if (typeof value !== "boolean") {
    throw new TypeError(
      `${path} deve ser boolean (recebeu: ${describe(value)})`,
    );
  }
  return value;
}

export function ensureArrayOfStrings(value: unknown, path: string): string[] {
  if (!Array.isArray(value)) {
    throw new TypeError(
      `${path} deve ser um array de strings (recebeu: ${describe(value)})`,
    );
  }
  for (let i = 0; i < value.length; i++) {
    const item = value[i];
    if (typeof item !== "string" || item.length === 0) {
      throw new TypeError(
        `${path}[${i}] deve ser uma string não vazia (recebeu: ${describe(item)})`,
      );
    }
  }
  return value;
}
